// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"8c88ca71","453":"d1994899"}[chunkId] + ".chunk.js";
};